import { loadData, UserDataProvider } from "../../../Core/UserDataProvider"
import { StatusLogsQueryParams, TelegramReportsQueryParams } from "../../../DataTypes/report"
import { controllers } from "../../Controllers"


class ReportController {
    // Scoping (a regular Lead Manager only sees logs for their own leads,
    // an admin sees everyone's) is enforced entirely server-side.
    listLogs = async (params: StatusLogsQueryParams = {}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.listStatusLogs, {userToken, ...params})
        return response
    }

    markLogRead = async (logId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.markStatusLogRead(logId, body), {userToken})
        return response
    }

    markAllLogsRead = async () => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.markAllStatusLogsRead, {userToken})
        return response
    }

    // Everything visible to this user that hasn't been sent in a report yet.
    getUnreportedLogs = async () => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getUnreportedStatusLogs, {userToken})
        return response
    }

    // Soft-delete — stays in the database, just excluded from normal
    // listings and no longer reportable.
    trashLog = async (logId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.trashStatusLog(logId, body), {userToken})
        return response
    }

    restoreLog = async (logId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.restoreStatusLog(logId, body), {userToken})
        return response
    }

    // History of previously sent reports — own only, unless lead-admin.
    listSentReports = async (params: TelegramReportsQueryParams = {}) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.listTelegramReports, {userToken, ...params})
        return response
    }

    getSentReportDetail = async (reportId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.getTelegramReportDetail(reportId, body), {userToken})
        return response
    }

    saveTelegramChatId = async (telegramChatId: string) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.saveTelegramChatId, {userToken, telegram_chat_id: telegramChatId})
        return response
    }

    // Only the entries in entryIds get marked is_reported — anything left
    // unchecked on the Report screen stays available for next time.
    // additionalMessage is a free-text note appended once at the end of the
    // whole report, separate from any per-entry content the backend adds.
    sendReport = async (entryIds: number[], additionalMessage: string = '') => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.sendTelegramReport, {
            userToken,
            entry_ids: entryIds,
            additional_message: additionalMessage,
        })
        return response
    }


    getReplyNotifications = async (limit: number = 20) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.getReplyNotifications, {userToken, limit})
        return response
    }

    markReplyNotificationRead = async (emailId: number) => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData((body:any) => UserDataProvider.markEmailRead(emailId, body), {userToken})
        return response
    }

    markAllReplyNotificationsRead = async () => {
        const { userToken } = controllers().auth
        if(!userToken) return
        const response = loadData(UserDataProvider.markAllReplyNotificationsRead, {userToken})
        return response
    }
}

export { ReportController }
